<template>
  <el-dialog title="Status Track" :close-on-click-modal="false" :visible.sync="visible" width="1400px" top="3vh">
    <div>
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @submit.native.prevent="getDataList(1)">
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndSecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Date"
            end-placeholder="Ending Date"
            @change="getDataList(1)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt20 pb20">
      <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column prop="createAt" align="center" label="Handling Time" width="130">
          <template slot-scope="scope">
            {{ scope.row.createAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column prop="clientCode" align="center" label="Client code" width="100"></el-table-column>
        <el-table-column prop="country" align="center" label="Country"></el-table-column>
        <el-table-column align="center" label="Status" width="130">
          <template slot-scope="scope">
            <p>{{ clientCodeStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Introduced By" width="126">
          <template slot-scope="scope">
            <p>{{ introducedByFormat(scope.row.introducedBy) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Commission" min-width="130">
          <template slot-scope="scope">
            <p v-for="item in scope.row.commissionList" :key="`commission${item.id}`" class="mt0 mb0">
              {{ item.name }} - {{ item.commissionRate | percentage }}
              <el-popover placement="bottom" trigger="hover" v-if="item.remark">
                <div class="fs12 lh20 enbr" style="max-width: 300px">{{ item.remark }}</div>
                <span slot="reference" class="fs14 lightGray el-icon-info"></span>
              </el-popover>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="introducer" align="center" label="Introducer" min-width="120"></el-table-column>
        <!-- <el-table-column prop="remark" align="center" label="Description / Remark" min-width="120" /> -->
        <el-table-column align="center" label="Handler">
          <template slot-scope="scope">
            <span>{{ scope.row.userInfo.nickname }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import searchMixin from "@/mixins/searchMixin";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [paginationMixin, searchMixin, filtersMixin, formatterMixin],
  components: { Pagination },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataForm: {
        clientId: null,
        startTime: "",
        endTime: "",
      },
      watchStartToEndSecondTimeRange: null,
    };
  },
  methods: {
    async init(id) {
      this.visible = true;
      await this.$nextTick();
      this.dataForm = {
        clientId: id,
        startTime: "",
        endTime: "",
      };
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/clientCodeInfoLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            ...this.dataForm,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>
